import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import { useNawiChatActions, useNawiChatComposer } from './NawiChatContext';

const ScrollDownButton = ({ onClick }) => (
  <button
    aria-label={I18n.t('persons.nawiChat.scrollDown')}
    className="nawi-chat__scroll-down scroll-down-fab"
    onClick={onClick}
    type="button"
  >
    <svg
      aria-hidden="true"
      fill="none"
      height="16"
      stroke="currentColor"
      strokeWidth="2.5"
      viewBox="0 0 24 24"
      width="16"
    >
      <polyline points="6 9 12 15 18 9" />
    </svg>
  </button>
);

ScrollDownButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

const StopButton = ({ onClick }) => (
  <button
    aria-label={I18n.t('persons.nawiChat.stop')}
    className="chat-stop-btn"
    onClick={onClick}
    title={I18n.t('persons.nawiChat.stop')}
    type="button"
  >
    <span className="chat-stop-square" />
  </button>
);

StopButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

const ChatComposer = () => {
  const {
    handleInputChange,
    handleKeyDown,
    handleScrollDown,
    handleStop,
    handleSubmit,
  } = useNawiChatActions();
  const {
    inputValue,
    isQuotaBlocked,
    isResponding,
    showScrollButton,
    textareaRef,
  } = useNawiChatComposer();

  return (
    <div className="nawi-chat__dock">
      {showScrollButton && <ScrollDownButton onClick={handleScrollDown} />}
      <form className="nawi-chat__composer" onSubmit={handleSubmit}>
        <textarea
          aria-label={I18n.t('persons.nawiChat.inputLabel')}
          disabled={isResponding || isQuotaBlocked}
          maxLength={1000}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          placeholder={I18n.t('persons.nawiChat.placeholder')}
          ref={textareaRef}
          rows={1}
          value={inputValue}
        />
        <div className="nawi-chat__composer-actions">
          <span>{I18n.t('persons.nawiChat.model')}</span>
          <div className="chat-toolbar-right">
            {isResponding && <StopButton onClick={handleStop} />}
          </div>
        </div>
      </form>
      <p className="nawi-chat__disclaimer">
        {I18n.t('persons.nawiChat.disclaimer')}
      </p>
    </div>
  );
};

export default ChatComposer;
